import React from 'react';
import styles from '../style/UserPage.module.css'; // 기존 스타일 공유

export const MessageModal = ({ message, onClose, onConfirm, showCancel, t = (s) => s }) => (
  <div className={styles.confirmModalOverlay}>
    <div className={styles.confirmModalContent}>
      <p className={styles.confirmMessage}>{message}</p>
      <div className={styles.confirmActions}>
        <button onClick={onConfirm} className={styles.confirmBtn}>{t('userPage.confirmButton') || 'Confirm'}</button>
        {showCancel && <button onClick={onClose} className={styles.cancelBtn}>{t('userPage.cancelButton') || 'Cancel'}</button>}
      </div>
    </div>
  </div>
);

export const FollowModal = ({ title, users, onClose, onUserClick, t }) => (
  <div className={styles.confirmModalOverlay} onClick={onClose}>
    <div className={styles.confirmModalContent} onClick={(e) => e.stopPropagation()}>
      <div className={styles.followModalHeader}>
        <h3 className={styles.followModalTitle}>{title}</h3>
        <button onClick={onClose} className={styles.closeModalBtn}>&times;</button>
      </div>
      <ul className={styles.followModalList}>
        {users.length > 0 ? users.map(user => (
          <li key={user.userId} className={styles.followListItem}>
            <div className={styles.followUserContainer} onClick={() => onUserClick(user.userId)} style={{ cursor: 'pointer' }}>
              <div className={styles.followUserAvatar}>
                {user.profileImageUrl ? <img src={user.profileImageUrl} alt={user.nickname} className={styles.avatarImage} /> :
                  <span className={styles.avatarPlaceholder}>{user.nickname?.charAt(0).toUpperCase() || '?'}</span>}
              </div>
              <span className={styles.followUserLink}>{user.nickname}</span>
            </div>
          </li>
        )) : <p className={styles.emptyMessage}>{t('userPage.noUsersFound')}</p>}
      </ul>
    </div>
  </div>
);